import React, { Component } from 'react';

export default class cLink extends Component {
  handleOnClick = () => {
    this.props.onClick(this.props.id);
  };
  render() {
    return (
      <a style={this.props.style} className={this.props.className} onClick={this.handleOnClick}>
        {this.props.children}
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cLink.js